customElements.whenDefined('product-card').then(() => {
    const ProductCard = customElements.get('product-card');

    class ProductCardCustom extends ProductCard {
        constructor() {
            super();
        }

        connectedCallback() {
            this.updateSwatchCount();
            window.addEventListener('resize', () => this.updateSwatchCount());
        }

        updateSwatchCount() {
            const container = this.querySelector('.card__swatches');
            if (!container) return;

            const swatches = Array.from(container.querySelectorAll('label'));
            const additional = container.querySelector('.text-end');

            if (!swatches) return;

            const displayedSwatchCount = swatches.filter(swatch => swatch.offsetParent !== null).length;

            const expectedSwatchCount = container.dataset?.swatchCount;
            const swatchCountDiff = expectedSwatchCount - displayedSwatchCount;

            if (additional) {
                additional.innerText = swatchCountDiff > 0 ? `+${swatchCountDiff}` : '';
            } else if (swatchCountDiff > 0) {
                const additionalEl = document.createElement('span');
                additionalEl.classList.add('self-center', 'text-end', 'text-sm');
                additionalEl.innerText = `+${swatchCountDiff}`;
                container.append(additionalEl);
            }
        }
    }

    customElements.define('product-card-custom', ProductCardCustom);
});
